import memoize from 'lru-memoize';
import {ReactNode} from 'react';

import {Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {AnswerFolderModel} from '../../../../models/api/answerFolderModel';
import {AnswerModel} from '../../../../models/api/answerModel';

/*
 * Dropdown Item Types.
 */

export enum AnswersDropdownItemTypesEnum {
  ANSWER = 'ANSWER',
  FOLDER = 'FOLDER',
  HEADER = 'HEADER',
  CREATE = 'CREATE',
}

export enum AnswersDropdownAnswerTypesEnum {
  RECENT = 'recent',
  CURRENT_FOLDER = 'all',
}

export interface DropdownItemAnswer {
  type: AnswersDropdownItemTypesEnum.ANSWER;
  answer: AnswerModel;
  answerType: AnswersDropdownAnswerTypesEnum;
}

export interface DropdownItemAnswerFolder {
  type: AnswersDropdownItemTypesEnum.FOLDER;
  folder: AnswerFolderModel;
}

export interface DropdownItemHeader {
  type: AnswersDropdownItemTypesEnum.HEADER;
  title: Renderer;
}

export interface DropdownItemCreate {
  type: AnswersDropdownItemTypesEnum.CREATE;
}

export type DropdownItem =
  | DropdownItemAnswer
  | DropdownItemAnswerFolder
  | DropdownItemHeader
  | DropdownItemCreate;

export function isDropdownItemAnswerFolder(item: DropdownItem): item is DropdownItemAnswerFolder {
  return item.type === AnswersDropdownItemTypesEnum.FOLDER;
}

/*
 * Dropdown Item Builders.
 */

export function buildHeaderDropdownItem(label: ReactNode): DropdownItemHeader {
  return {
    type: AnswersDropdownItemTypesEnum.HEADER,
    title: () => label,
  };
}

export function buildCreateNewAnswerDropdownItem(): DropdownItemCreate {
  return {
    type: AnswersDropdownItemTypesEnum.CREATE,
  };
}

function makeBuildAnswerDropdownItem(answerType: AnswersDropdownAnswerTypesEnum) {
  return (answer: AnswerModel): DropdownItemAnswer => ({
    type: AnswersDropdownItemTypesEnum.ANSWER,
    answer,
    answerType,
  });
}

export const buildRecentAnswerDropdownItem = (answer: AnswerModel) =>
  makeBuildAnswerDropdownItem(AnswersDropdownAnswerTypesEnum.RECENT)(answer);

export const buildCurrentFolderAnswersDropdownItem = memoize(20)((answer: AnswerModel) =>
  makeBuildAnswerDropdownItem(AnswersDropdownAnswerTypesEnum.CURRENT_FOLDER)(answer),
);

export const buildAnswerFolderDropdownItem = memoize(20)(
  (folder: AnswerFolderModel): DropdownItemAnswerFolder => ({
    type: AnswersDropdownItemTypesEnum.FOLDER,
    folder,
  }),
);
